import { computed, Directive, input } from '@angular/core';

type ButtonSize = 'XS' | 'S' | 'M' | 'L';

export enum ButtonBasicFlavor {
	DEFAULT = 'DEFAULT',
	SUCCESS = 'SUCCESS',
}

const BUTTON_CLASS_BY_SIZE: Record<ButtonSize, string> = {
	XS: 'px-1 py-0.5 rounded-0.75 gap-0.5',
	S: 'px-1.5 py-0.5 rounded-1 gap-0.75',
	M: 'px-2 py-1 rounded-1 gap-1',
	L: 'px-3 py-1.5 rounded-1 gap-1',
};

@Directive({
	selector: '[buttonBasic],[buttonSimple]',
	standalone: true,
	host: {
		class: 'text-m flex items-center justify-start',
		'[class.fc-400]': '!$active()',
		'[class.fc-800]': '$active()',
		'[class.bg-primary/20]': '$active() && $flavor() !== "SUCCESS"',
		'[class.hover:bg-standard-hover]': '!$disabled() && !$active() && $flavor() !== "SUCCESS"',
		'[class.hover:fc-500]': '!$disabled() && $flavor() !== "SUCCESS"',
		'[class.text-node-type]': '$flavor() === "SUCCESS"',
		'[class.node-website]': '$flavor() === "SUCCESS"',
		'[class.bg-success-node-hover]': '$flavor() === "SUCCESS"',
		'[class]': '$sizeClasses()',
		'[attr.disabled]': '$disabled() ? "true" : null',
		style: '--spacing: 8px; transition: background-color 300ms, color 300ms;',
	},
})
export class ButtonBasicDirective {
	public readonly $size = input<ButtonSize>('M', { alias: 'size' });

	public readonly $active = input(false, { alias: 'active' });

	// flavor acepta valores del enum ButtonBasicFlavor; de momento solo SUCCESS
	public readonly $flavor = input(ButtonBasicFlavor.DEFAULT, {
		alias: 'flavor',
	});

	public readonly $disabled = input<boolean, boolean | 'true' | 'false'>(false, {
		alias: 'disabled',
		transform: (value) => {
			return `${value}` === `true`;
		},
	});

	protected readonly $sizeClasses = computed(() => {
		const size = this.$size();
		return BUTTON_CLASS_BY_SIZE[size] ?? '';
	});
}
